module.exports = __webpack_public_path__ + "bg-triple2.jpg";